// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__mao-v","modal-container":"styles_modal-container__YOjxT","header-padding":"styles_header-padding__XEDBx"};